'use strict';

var angular = require('angular');
var dependencies = ['AVRO.Common.DistanceUnit', 'AVRO.Common.FeatureToggle'];
module.exports = angular.module('AVRO.Rules.CommonData', dependencies).factory('ConditionsAndActionsService', require('./services/ConditionsAndActionsService')).factory('ElementServiceProvider', require('./services/ElementServiceProvider')).factory('PanelStateManager', require('./services/PanelStateManager'));